// eslint-disable-next-line import/prefer-default-export
export const ADMIN_ES = {
  // Datos para Enviar el NPS
  sendNps: 'Enviar NPS',
  textH1: '¿Seleccione plantilla de NPS a enviar?',
  // Common actions and words
  Accept: 'Aceptar',
  Cancel: 'Cancelar',
  Save: 'Guardar',
  Delete: 'Eliminar',
  Edit: 'Editar',
  Update: 'Actualizar',
  Vacancy: 'Vacante',
  Add: 'Agregar',

  // MAIN SIDENAV
  CandidatesBase: 'Base de candidatos',
  Analytics: 'Analíticas',
  GeneralAdmin: 'Admin general',
  Multiposting: 'Multiposting',
  Invoices: 'Facturas',
  DataStudio: 'Data studio',
  GeneralAnalytics: 'Analíticas generales',
  newAccounts: 'Nuevas cuentas',

  // /////////////////////////////////////
  // ADMIN
  GeneralStep: 'General',
  VisualEditorStep: 'Editor visual',
  UsersStep: 'Usuarios',
  MailingStep: 'Correos',

  // general step
  GeneralGenStep: 'General',
  APIGenStep: 'Integraciones',
  PaymentsGenStep: 'Pagos',
  TemplatesGenStep: 'Plantillas',
  Industry: 'Industria',
  industryMessage: 'Seleccione la industria a la cual pertenece su empresa.',
  spontaneousVacancy: 'Vacante espontánea',
  spontaneousVacancyMessage:
    "Vacantes a las cuales los candidatos podrán postularse, podrás observar sus CV's y transferirlos a una vacante que te interese",
  acceptSpontaneous: 'Aceptar candidatura espontánea',
  English: 'Inglés',
  Spanish: 'Español',
  Language: 'Idioma',
  selectLanguageMessage: 'Seleccione el idioma en el que desea usar la plataforma',
  // Api page
  SelfHostingMessage: 'Escriba el subdominio a montar',
  TooltipSubdomain: 'Subdominio principal en el cual se cargaré la información de nuestra plataforma.',
  placeholderSubdomain: 'Subdominio',
  Integrations: 'Integraciones',
  ImplementationWithThePlatform: 'Implementación en la plataforma',
  SlackOptions: 'Opciones de Slack',
  TeamsOptions: 'Opciones de Teams',
  BambooIntegration: 'Integración con BambooHR',
  BambooMessage:
    'Para realizar la integración necesitamos su dominio y una clave API de administrador de BambooHR, por favor ingrese los datos: ',
  ApiKey: 'Clave API:',
  Domain: 'Dominio: ',
  HowToGetTheKey: '¿Cómo obtener la clave de API de BambooHR?',
  WhichIntegrationMode: '¿En qué momento quiere importar la información de sus candidatos a BambooHR?',
  WhenAccepted: 'Cuando el candidato es aceptado',
  WhenApplied: 'Desde que el candidato se postula',
  Instruction1: '1. Inicie sesión en su dominio de BambooHR: ',
  Instruction2: '2. Dé clic en su nombre en la esquina superior derecha para ver el menuPop.',
  Instruction3: '3. Dé clic en la opción "Llaves API" (Debe tener suficentes permisos para tener esta opción).',
  Instruction4: '4. Ingrese un nombre para la clave y dé clic en "Generar llave". Copie y guarde la llave.',
  ComingSoon: '¡Próximamente!',
  // Payments page
  startupMessage: 'Tu plan Startup es gratis por siempre',
  ProfessionalMessage1: 'Tu plan',
  ProfessionalMessage2: 'se renueva el: ',
  ChangePlan: 'Cambiar plan',
  ChargeLimit: 'Límite de cobro mensual',
  SendInvoicesTo: 'Enviar facturas a:',
  SomeOfOurBenefits: 'Algunos de nuestros beneficios',
  benefit1: 'Multiposteo a +100 institutos',
  benefit2: 'Página Careers personalizada ',
  benefit3: 'Habilidades duras personalizadas',
  benefit4: 'Pruebas a candidatos',
  PaymentMethod: 'Método de pago',
  AddCard: 'Agregar tarjeta de crédito / débito',
  UpdateCard: 'Actualizar tarjeta de crédito / débito',
  Cardholder: 'Titular',
  CardInfo: 'Datos de la tarjeta',
  BillingInfo: 'Datos de facturación',
  FullName: 'Nombre completo',
  FiscalNumber: 'No. fiscal',
  Adress: 'Dirección',
  City: 'Ciudad',
  ZipCode: 'CP',
  BillingNotes: 'Notas de facturación',
  // Templates page
  Templates: 'Plantillas',
  Columns: 'Columnas',
  SearchTemplates: 'Buscar plantillas',
  CreateTemplate: 'Crear plantilla nueva',
  CreatedBy: 'Creado por',
  TemplateName: 'Nombre de plantilla',
  CreatedAt: 'Fecha de creación',
  Type: 'Tipo',
  Actions: 'Acciones',
  tooltipDeleteColumn: 'Eliminar columna',
  tooltipMoveColumn: 'Mover columna',
  tooltipAddAdmins: 'Agregar administradores',
  // modalDeleteTemplate
  DeleteTamplateHeader: 'Eliminar plantilla',
  DeleteTemplateConfirmation: '¿Seguro que desea eliminar esta plantilla?',
  DeleteTemplateWarning: 'Las plantillas eliminadas no se podrán recuperar.',
  // modalCreateTemplate
  CreateTemplateHeader: 'Crear plantilla de columna',
  NewApplicants: 'Nuevos candidatos',
  RejectedApplicants: 'Rechazados',
  AcceptedApplicants: 'Aceptados',
  AddColumn: 'Agregar columna',
  TemplateActive: 'Activa',
  placeholderTemplateName: 'Nombre de la plantilla',
  NewTemplate: 'Nueva plantilla',

  // Visual Editor
  imgVacancy: 'Img. vacante',
  Watch: 'Ver',
  Help: 'Ayuda',
  AboutUs: 'Acerca de nosotros',
  Employment: 'Empleo',
  Location: 'Ubicación',
  OurTeam: 'Nuestro equipo',
  Installations: 'Oficina',
  OurCulture: 'Nuestra Cultura',
  OurInstallationsAndPerks: 'Nuestras Instalaciones y Beneficios',
  MainText: 'Texto principal',
  Office: 'Oficina',
  AddImageHeader: 'Agregar imagen para vacantes',
  PredefinedImageMessage: 'Esta será la imagen predefinida para nuevas vacantes',
  tooltipEditImage: 'Editar imagen',
  tooltipEditText: 'Editar texto',
  tooltipEditTeam: 'Editar equipo',
  tooltipEditCulture: 'Editar cultura',
  tooltipEditOffices: 'Editar oficinas',
  NoInfo: 'Sin información por el momento',
  Background: 'Fondo',
  EditPage: 'Editar página',
  ChangeMainTitle: 'Cambiar título principal',
  hangeTitle: 'Cambiar título',
  ChangeDescription: 'Cambiar descripción',
  ChangeText: 'Cambiar texto',
  ChangeSubtitle: 'Cambiar subtítulo',
  TellUsMore: 'Cuéntanos más',
  CollaboratorName: 'Nombre del colaborador',
  ImgOrVideo: 'Imagen o video',
  Post: 'Puesto',
  PhotoUrl: 'Url de foto o video',
  ExecutiveTeam: 'Equipo Ejecutivo',

  // User Admin
  AddUser: 'Agregar usuario',
  SearchBy: 'Buscar por nombre',
  AllDepartments: 'Todos',
  adminType: 'Tiene todos los accesos y permisos de la plataforma.',
  recruiterType:
    'Tiene los mismos accesos que el Admin excepto acceso a la sección “Admin General” que incluye temas de integraciones, usuarios, pagos, mailings, etc.',
  userType: 'Acceso limitado. Solo puede ver las vacantes a las cuales se le da acceso.',
  Recruiter: 'Reclutador',
  User: 'Usuario',
  // modalConfirmation
  DeleteUser: 'Delete user',
  Warning: 'Esta acción no se puede deshacer. Esto eliminará permanentemente al usuario:',
  PleaseType: 'Por favor escriba ',
  ToConfirm: ' para confirmar: ',
  // modalDepartment
  AddDepartment: 'Agregar departamento',
  PlaceholderAddDepartment: 'Agregar / Editar departamento',
  // modalAddUser
  UploadAPhoto: 'Sube una foto',
  Name: 'Nombre',
  LastName: 'Apellidos',
  Email: 'Correo electrónico',
  Phone: 'Teléfono',
  HowToGetIt: '¿Cómo obtenerlo?',
  UserType: 'Tipo de usuario',
  placeholderName: 'Nombre del usuario',
  placeholderLastName: 'Apellidos del usuario',
  placeholderEmail: 'Correo del usuario',
  placeholderSlackId: 'ID de usuario de Slack (opcional)',

  // Mailing
  EmailPr: 'Correo de proceso',
  EmailRe: 'Correo de rechazo',
  EmailAc: 'Correo de aceptación',
  EmailPrBody:
    'Este es el correo que recibe el candidato que es movido de la columna "Nuevo candidato" a cualquiera de las siguientes columnas del proceso de selección.',
  EmailReBody:
    'Este es el correo que el candidato recibe al momento de llegar a la columna "Rechazados". ¿Cómo quieres notificarle al candidato que no será considerado para la vacante?',
  EmailAcBody:
    'Cuando has decidido que este es el candidato ideal y arrastras a un candidato a la columna de "Aceptados", el candidato recibirá este correo electrónico automático.',
  titleTemplateMail: 'Plantillas de correos',
  // modalChangeEmailBody
  EditEmailBody: 'Edite el cuerpo del correo',
  ImportantInfo: 'Datos importantes',
  Company: 'Empresa',
  Applicant: 'Candidato',

  // Test
  testQuestion: 'Pregunta',
  testImg: 'Imagen',
  testOptional: 'Opcional',
  testType: 'Típo',
  testTime: 'Tiempo',
  testAnswer: 'Respuesta Correcta',
  // Kind of questions
  // Admin
  testTemplateMenu: 'P. Personalizadas',
  testTemplateTitle: 'Plantillas de Quiz',
  testTemplateName: 'Nombre de la Plantilla',
  templateNPSTitle: 'Encuestas de satisfacción(NPS)',
  templateNPSButton: 'Crear Nuevo',
  templateNPSEliminar: 'Eliminar',
  // Jobs
  testImportTemplate: '¿Gustas importar una plantilla?',
  testOpenQuestion: 'Pregunta Abierta',
  testLongAnswer: 'Pregunta Abierta (Respuesta Extensa)',
  testClosedQuestion: 'Pregunta Cerrada (Si y No)',
  testMultipleChoiceQuestion: 'Pregunta de Opción multiple',
  testQuestionAboutRanks: 'Pregunta sobre Rangos',
  QuestionType: 'Tipo de pregunta',
  testOption: 'Opción',
  addImgTest: 'Agregar imagen para la pregunta.',
  buttonNewTest: 'Guardar Plantilla de Test',
  buttonUpdateTest: 'Actualizar Plantilla de Test',
  QuestionsPersonal: 'Preguntas Personalizadas',
  QuestionsPersonalH2: 'Tus Preguntas',
  QuestionsEditorH2: 'Creador de preguntas',
  QuestionsWill: 'Tus preguntas aparecerán aquí',
  // Modal Save Test
  modalSaveTest: 'Nombre de plantilla',
  addSaveTest: 'Agregar',
  updateSaveTest: 'Actualizar',
  addCancelTest: 'Cancelar',
  SelectAnAnswer: 'Seleccione una respuesta',

  // NPS

  titleLayout: 'Diseño',
  titleImg: 'Imagen',
  titlePosition: 'Posición',
  // Color
  colorQuestion: 'Preguntas',
  colorAnswer: 'Respuestas',
  typeQuestion: 'Tipo de pregunta',
  typeInputQuestion: 'Escriba su respuesta aquí ...',
  npsYes: 'Si',
  npsNo: 'No',
  npsChose: 'elegir',
  npsAddChoice: 'Agregar opción',
  npsTitleSettings: 'Configuración',
  npsProgressBar: 'Barra de progreso',
  npsNavigationArrows: 'F. de navegación',
  npsRedirect: 'Redirect',
  // Big Brother HH
  bigBrotherTitle: 'Big Brother HH',
  labelCompanyName: 'Nombre de la empresa',
  labelCompanyEmail: 'Correo público',
  labelSiteWeb: 'Sitio web',
  labelCompanyPhone: 'Teléfono',
  labelCompanyLocation: 'Ubicación',
  labelCompanyDescription: 'Descripción',
  labelCompanyData: 'Un poco de historia',
  labelCompanyLogo: 'Agregar logo de la empresa',
  labelImgVacancy: 'Agregar imagen de vacante',
  SelectCompany: 'Seleccionar plantilla de empresa',
  labelChangeImg: 'Arrastre y suelte el logo aquí o haga clic para seleccionar el logo',

  // Score criteria with weight
  ScoreCriteria: 'Criterios de calificación',
  TemplateNameCriteria: 'Nombre de la plantilla',
  CriterionName: 'Nombre del criterio',
  CriterionWeight: 'Peso del criterio',
  AddCriterion: 'Agregar criterio',
  Weight: 'Peso',
  NameCriterionHeader: 'Nombre',
  TemplateUpdated: 'Plantilla actualizada',
  TemplateSaved: 'Plantilla creada',
  ErrorWhileUpdating: 'Erro actualizando la plantilla',
  WeightInvalidValue: 'El valor del peso debe ser entre 0.1 y 10',
  MustNameCriterion: 'Debe asignar un nombre al criterio',

  // Notificaciones de Test Personalizado
  notificationOptionAnswer: 'Se solicita 2 opciones como minimo para ser pregunta cerrada y seleccionar una respuesta',
  notificationAddTest: 'Su cuestionario personal fue guardado',
  notificationErrorTest: 'Se requiere un nombre para la plantilla.',
  notificationSuccessTestUpdate: 'Plantilla de Test actualizado.',
  notificationErrorTestUpdate: 'Error en guardar la plantilla.',
  // Notifications
  LettersNotAllowed: 'No se permiten letras',
  SubdomainEmpty: 'Campo de subdominio está vacío',
  DistinctSubdomain: 'Use un subdominio diferente al anterior',
  OnlySubdomainAllowed: 'Solo subdominio es permitido',
  UpdateSuccessfullyDone: 'Actualización exitosa',
  CouldNotMoveColumn: 'No fue posible mover la columna, inténtelo de nuevo',
  TemplateDeleted: 'Plantilla eliminada',
  Only10Values: 'Solo puede seleccionar 10 valores',
  ValuesUpdated: 'Valores actualizados',
  SendingInfo: 'Enviando datos...',
  MustFillAllFields: 'Debe rellenar todos los campos',
  IntegrationError: 'Clave inválida, la clave debe consistir de 40 caracteres',
  IntegrationSuccess: 'Integration realizada exitosamente',

  // Grids
  emptyTest: 'No hay información para mostrar',
  publish: 'Publicar',
};
